import React from 'react';
import DefectsTable from '../components/defectsTable';

const RepairsReport = () => {
  // No assetId passed - shows all defects unfiltered
  return <DefectsTable />;
};

export default RepairsReport;
